

export class FuelStationOutputWithStatus implements IFuelStationOutputWithStatus {
    /** The auto-generated id of the fuel station master */
    fuel_station_id!: number;
    /** The fuel station name with 255 character limit */
    fuel_station_name!: string;
    /** Manage status of alert type. 0 For De-active, 1 For Active */
    status!: number;

    constructor(data?: IFuelStationOutputWithStatus) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.fuel_station_id = _data["fuel_station_id"];
            this.fuel_station_name = _data["fuel_station_name"];
            this.status = _data["status"];
        }
    }

    static fromJS(data: any): FuelStationOutputWithStatus {
        data = typeof data === 'object' ? data : {};
        let result = new FuelStationOutputWithStatus();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["fuel_station_id"] = this.fuel_station_id;
        data["fuel_station_name"] = this.fuel_station_name;
        data["status"] = this.status;
        return data; 
    }
}

export interface IFuelStationOutputWithStatus {
    /** The auto-generated id of the fuel station master */
    fuel_station_id: number;
    /** The fuel station name with 255 character limit */
    fuel_station_name: string;
    /** Manage status of alert type. 0 For De-active, 1 For Active */
    status: number;
}

